import { color as designColor, font, query } from '@design/templateFns';
import { ThemeColorName } from '@design/theme';
import { ThemeFontName } from '@design/types';
import styled from 'styled-components';
import { TypographyProps } from '../types';
import { ReactNode } from 'react';

const StyledBodyCopy = styled.div<{
  $desktopFont?: ThemeFontName;
  $tabletFont?: ThemeFontName;
  $mobileFont?: ThemeFontName;
  $color?: ThemeColorName;
}>`
  ${({ $desktopFont }) => ($desktopFont ? font($desktopFont) : '')};
  color: ${({ $color }) => ($color ? designColor($color) : designColor('fg'))};
  @media screen and (${query.below('desktop')}) {
    ${({ $tabletFont }) => ($tabletFont ? font($tabletFont) : '')};
  }
  @media screen and (${query.below('tablet')}) {
    ${({ $mobileFont }) => ($mobileFont ? font($mobileFont) : '')};
  }
`;

const BodyCopy = ({
  as,
  children,
  desktopFont,
  tabletFont,
  mobileFont,
  color,
}: TypographyProps): ReactNode => {
  return (
    <StyledBodyCopy
      as={as}
      $desktopFont={desktopFont}
      $tabletFont={tabletFont}
      $mobileFont={mobileFont}
      $color={color}
    >
      {children}
    </StyledBodyCopy>
  );
};

export default BodyCopy;
